
import { Button } from "@/components/ui/button";
interface AuthFormButtonsProps {
  isSignUp: boolean;
  loading: boolean;
  isCheckingSchoolId: boolean;
  onToggleMode: () => void;
}
export const AuthFormButtons = ({
  isSignUp,
  loading,
  isCheckingSchoolId,
  onToggleMode
}: AuthFormButtonsProps) => {
  return <>
      <div>
        <Button 
          type="submit" 
          disabled={loading || isCheckingSchoolId} 
          className="w-full rounded-full bg-[#008169] hover:bg-[#006e59] text-white"
        >
          {loading || isCheckingSchoolId ? "Memproses..." : isSignUp ? "Daftar" : "Masuk"}
        </Button>
      </div>
      <div className="text-center">
        <Button 
          type="button" 
          variant="link" 
          onClick={onToggleMode} 
          disabled={loading || isCheckingSchoolId}
          className="text-[#008169] hover:text-[#006e59]"
        >
          {isSignUp ? "Sudah punya akun? Masuk" : "Belum punya akun? Daftar"}
        </Button>
      </div>
    </>;
};
